import { ValidationArguments, ValidatorConstraint, ValidatorConstraintInterface, Validator } from 'class-validator';
import { CustomCommonValidator } from './customCommonValidator';

@ValidatorConstraint()
export class ClientContactValidation extends CustomCommonValidator implements ValidatorConstraintInterface {

    validate(dynamicProperties: any, validationArguments: ValidationArguments) {
        let properties: string[] = Object.getOwnPropertyNames(dynamicProperties);
        let result: boolean = true;
        const validator = this.getValidator();
        this.message = '';

		if (properties.find(p => p == 'email') != null) {
            let email: string = dynamicProperties['email'];
            if (!validator.isEmail(email)) {
                result = false;
                this.message = this.message.concat('email has bad format <br />');
            }
        }
        if (properties.find(p => p == 'mobilePhone') != null) {
            let mobilePhone: string = dynamicProperties['mobilePhone'];
            if (!validator.matches(mobilePhone, /\(?\d+\)?[-.\s]?\d+[-.\s]?\d+$/ )) {
                result = false;
                this.message = this.message.concat(' MobilePhone is not a mobile phone <br />');
            }
        }
        if (properties.find(p => p == 'workPhone') != null) {
            let workPhone: string = dynamicProperties['workPhone'];
            if (!validator.matches(workPhone, /\(?\d+\)?[-.\s]?\d+[-.\s]?\d+$/)) {
                result = false;
                this.message = this.message.concat('WorkPhone is not a number phone <br />');
            }
        }
        if (properties.find(p => p == 'homePhone') != null) {
            let homePhone: string = dynamicProperties['homePhone'];
            if (!validator.matches(homePhone, /\(?\d+\)?[-.\s]?\d+[-.\s]?\d+$/)) {
                result = false;
                this.message = this.message.concat('HomePhone is not a number phone <br />');
            }
        }
        if (properties.find(p => p == 'fax') != null) {
            let fax: any = dynamicProperties['fax'];
            if (!validator.matches(fax.toString(), /\(?\d+\)?[-.\s]?\d+[-.\s]?\d+$/)) {
                result = false;
                this.message = this.message.concat('Fax is not a number fax <br />');
            }
        }
        return result;
	}

    defaultMessage(args: ValidationArguments) { // here you can provide default error message if validation failed
        return this.message;
    }

}



// WEBPACK FOOTER //
// ./src/core/customValidator/clientContactValidator.ts